import { MdOutlineMonitor, MdOutlineBuild, MdOutlineCloudQueue } from "react-icons/md";
import img1 from "../../../assets/img/Industries/Automotive/2149530078.jpg";
import { FaChartLine } from "react-icons/fa";
import { AiOutlineUser } from "react-icons/ai";
import { MdOutlineHealthAndSafety } from "react-icons/md";

export default function MainSection1() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="flex flex-col mb-6 justify-center lg:justify-center lg:flex-row md:mb-8">
        <h2 className="max-w-4xl mb-5 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none md:mb-6 group">
          <span className="inline-block mb-1 sm:mb-4">
            Our Solutions for Automotive
          </span>
          <div className="h-1 ml-auto duration-300 origin-left transform bg-primary scale-x-30 group-hover:scale-x-100" />
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              IoT-Enabled Smart Vehicle Solutions
            </h1>
            <p className="text-lg text-gray-600">
            Leverage IoT technology to revolutionize fleet management with real-time vehicle monitoring, predictive maintenance, and connected ecosystems. 
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdOutlineMonitor  className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Real-Time Vehicle Monitoring
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Leverage IoT sensors to continuously track key vehicle metrics
                such as engine performance, fuel efficiency, and system health.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdOutlineBuild  className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Predictive Maintenance
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Use IoT-powered predictive analytics to identify potential
                component failures before they occur, reducing downtime and
                maintenance costs.
              </p>
            </div>
            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdOutlineCloudQueue  className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Connected Ecosystems
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Create seamless communication between vehicles, drivers, and
                service centers, enabling smarter and more efficient fleet
                management.
              </p>
            </div>
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  );
}
